import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Checkbox} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class GlobalChecker extends Component {
  constructor(props) {
    super(props);
    this.handleCheckClick = this.handleCheckClick.bind(this);
  }

  handleCheckClick() {
    this.props.toggleAllProviderSpecialOrders();
  }

  render() {
    return (
      <Checkbox
        disabled={this.props.disabled}
        checked={this.props.checkedAll}
        onClick={this.handleCheckClick}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'checkedAll': state.providerOrdersList.checkedAll,
  };
};

const {toggleAllProviderSpecialOrders} = Actions;

export default connect(mapStateToProps, {toggleAllProviderSpecialOrders})(GlobalChecker);
